var classNames = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.reduce(function (acc, cur) {
        if (cur)
            return "".concat(acc, " ").concat(cur);
        return acc;
    }, "");
};
export default classNames;
